/*
 * "Subscribe & Save" pill on one-time cart lines (DS `components-cart.html`).
 *
 * snippets/cart-drawer.liquid renders the button on every one-time line that has
 * a selling plan available, already carrying the plan it should convert to (the
 * cart's own frequency when there is one). Clicking it POSTs that line to
 * /cart/change.js with the plan attached, then publishes cartUpdate so the
 * drawer re-renders, the header badge catches up and skio-cart-plan-sync.js
 * normalizes the whole cart onto the right single/multi plan set.
 *
 * Delegated from <document> rather than a custom element per line: Dawn replaces
 * the entire .drawer__inner on every cart update, so a listener bound to the
 * button would be thrown away on the first quantity change.
 */
(() => {
  if (window.__mlCartSubscribeLineLoaded) return;
  window.__mlCartSubscribeLineLoaded = true;

  function currentQuantity(button) {
    const input = button.dataset.quantityInput ? document.getElementById(button.dataset.quantityInput) : null;
    const live = input ? parseInt(input.value, 10) : NaN;
    if (!Number.isNaN(live) && live > 0) return live;

    const rendered = parseInt(button.dataset.lineQuantity, 10);
    return Number.isNaN(rendered) || rendered < 1 ? 1 : rendered;
  }

  function showError(message) {
    const errors = document.getElementById('CartDrawer-CartErrors');
    if (errors) {
      errors.textContent = message || (window.cartStrings && window.cartStrings.error) || 'There was an error updating your cart.';
    }
  }

  function subscribeLine(button) {
    if (button.getAttribute('aria-busy') === 'true') return;

    const lineKey = button.dataset.lineKey;
    const sellingPlanId = button.dataset.sellingPlanId;
    if (!lineKey || !sellingPlanId) return;

    const config =
      typeof fetchConfig === 'function'
        ? fetchConfig()
        : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };

    button.setAttribute('aria-busy', 'true');

    fetch(routes.cart_change_url, {
      ...config,
      body: JSON.stringify({
        id: lineKey,
        quantity: currentQuantity(button),
        selling_plan: sellingPlanId,
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        // /cart/change.js answers with the cart on success, {status, message, description} on failure
        if (cart.status) {
          // Flagged so the catch can tell an actionable cart message ("You can only
          // add 2 of this to the cart") from a network failure, which is noise.
          const cartError = new Error(cart.description || cart.message);
          cartError.fromCartApi = true;
          throw cartError;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ml-cart-subscribe-line', cartData: cart });
        }
        // No aria-busy reset on success: the re-render replaces this button entirely.
      })
      .catch((error) => {
        console.error('Cart subscribe line: change failed', error);
        showError(error && error.fromCartApi ? error.message : null);
        button.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-subscribe-line]');
    if (button) subscribeLine(button);
  });
})();
